import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import {useState, useEffect} from "react";

function ModelDropDown(props: any) {

    const { 
        selectedModel, 
        policyState,  
        year, 
        make,
        modelOptions,
        
        onModelChangeAction, 
        hasError,
        className, 
        parent } = props;

    const [models, setModels] = useState<string[]>([]);
    

    function onModelChange(model:string){
        onModelChangeAction(year, make, model);
    }

    useEffect(()=>{
        setModels(modelOptions);
    }, [models])

    return (
        
     <>
        <FormControl fullWidth>
            <InputLabel id="ddl-vehmodel">Model</InputLabel>
            <Select
                labelId="lbl-ddlVehicleModel"
                id="ddlVehicleModel"
                label="VehicleModel"
                value={selectedModel}
                onChange={(e)=>{onModelChange(e.target.value)}}
                error={hasError}
                className={className}>
                { 
                    models?.map((item:any) => (
                        <MenuItem key={item} value={item}>{item}</MenuItem>
                    ))
                }
            </Select>
            <FormHelperText className={"Mui-error"}>{(hasError ? "Model is required" : "")}</FormHelperText>
        </FormControl>
     </>   
    );
}

export default ModelDropDown;